import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useBiAction } from '../../../../BiTracking';
import styles from '../cells.module.scss';
export function EditableCell(param) {
    let { edit, children } = param;
    const logBiAction = useBiAction();
    const { onEdit, bi, testId } = edit;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        className: styles.editableValue,
        "data-testid": testId,
        onClick: (event)=>{
            logBiAction({
                entityType: 'button',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
            onEdit(event.currentTarget);
        },
        children: children
    });
}
